__turbopack_context__.v({
  "stickyEl": "PlanFeatures-module-scss-module__Mzb8Pq__stickyEl",
  "stickyElWrapper": "PlanFeatures-module-scss-module__Mzb8Pq__stickyElWrapper",
  "stickyFixed": "PlanFeatures-module-scss-module__Mzb8Pq__stickyFixed",
  "stickyPinnedBottom": "PlanFeatures-module-scss-module__Mzb8Pq__stickyPinnedBottom",
  "tooltipContent": "PlanFeatures-module-scss-module__Mzb8Pq__tooltipContent",
  "tooltipTrigger": "PlanFeatures-module-scss-module__Mzb8Pq__tooltipTrigger",
  "wrapper": "PlanFeatures-module-scss-module__Mzb8Pq__wrapper",
});
